import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';

const Container = styled.div`
  display: flex;
  flex-direction: ${({ isMobileDevice }) => (isMobileDevice ? 'column' : 'row')};
  justify-content: space-between;
  align-items: ${({ isMobileDevice }) => (isMobileDevice ? 'flex-start' : 'center')};
  gap: ${({ isMobileDevice }) => (isMobileDevice ? '8px' : '0px')};
  padding: ${({ isMobileDevice }) => (isMobileDevice ? '24px 16px 16px' : '24px')};
  white-space: normal;
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  word-wrap: break-word;
`;

const Note = styled.div`
  font-family: Hind;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: ${select('midDarkGrayAux')};
`;

export { Container, Title, Note };
